module.exports = __webpack_public_path__ + "2f57974f8bed2e8f9d0f02c86cf45b46.png";